/* Shopify owns email confirmation and verification-code delivery. */
document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-wholesale-signin]')) return;
  event.preventDefault();
  const email = form.elements.namedItem('login_hint');
  email.value = email.value.trim();
  if (!form.reportValidity()) return;
  const url = new URL(form.dataset.loginUrl, window.location.origin);
  url.searchParams.set('login_hint', email.value);
  // The storefront route supplies return_to; preserve it and all other parameters.
  window.location.assign(url.href);
});
